import styled from 'styled-components';

import { convertPxToRem } from '@proprioo/salatim';

export const AlertCardWrapper = styled.div`
  margin-top: ${convertPxToRem(24)};
`;
